import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import ProductCard from "@/components/shop/ProductCard";
import { AgeGate, hasTobaccoConsent } from "@/components/AgeGate";

export default function TobaccoPage() {
  usePageMeta("Tobacco Accessories (21+)", "Tobacco accessories department — 21 and over, ID checked on every purchase.");
  const [ok, setOk] = useState(hasTobaccoConsent());
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!ok) return;
    api
      .get("/products", { params: { category: "Tobacco Accessories", include_adult: true, limit: 60 } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, [ok]);

  if (!ok) return <AgeGate minAge={21} onConfirm={() => setOk(true)} />;

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-8 py-10" data-testid="tobacco-page">
      <div className="ipv-eyebrow text-[#C9971E]">21 and over · ID checked on every purchase</div>
      <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter text-[#0A1C40] mt-1">
        Tobacco Accessories
      </h1>
      <p className="text-sm text-gray-600 mt-2 max-w-2xl">
        Accessories only — no tobacco, nicotine, vapes, or e-liquid. Government photo ID is verified at pickup
        or delivery for every online order. Used items and all glass/ceramic are final sale; unopened items in
        original packaging may be exchanged or credited within 14 days with receipt and ID — never a cash refund.
      </p>
      {items === null ? (
        <div className="py-20 text-center text-gray-500">Loading…</div>
      ) : items.length === 0 ? (
        <div className="py-20 text-center text-gray-500" data-testid="tobacco-empty">
          Nothing here yet — check back soon.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mt-8">
          {items.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
